import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import {
	CustomerRoleGrantPathType,
	CustomerRoleGrantType,
	CustomerRoleRevokePathType,
	CustomerRoleSetPathType,
	CustomerRoleSetType,
} from '@schemas'

/** 역할 마스터 목록 — GET /customer-role */
export const getCustomerRoles = async ({
	query = {},
	body = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/customer-role'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 유효 역할 집합을 통째로 맞춘다 — PUT /customer-role/{customerId} { roleCodes } */
export const setCustomerRoles = async ({
	params = { customerId: '' } as CustomerRoleSetPathType,
	body = { roleCodes: [] } as CustomerRoleSetType,
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/customer-role/${params.customerId}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 역할 하나 부여 — POST /customer-role/{customerId} */
export const grantCustomerRole = async ({
	params = { customerId: '' } as CustomerRoleGrantPathType,
	body = { roleCode: '' } as CustomerRoleGrantType,
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/customer-role/${params.customerId}`
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

/** 역할 하나 회수 — DELETE /customer-role/{customerId}/{roleCode} */
export const revokeCustomerRole = async ({
	params = { customerId: '', roleCode: '' } as CustomerRoleRevokePathType,
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/customer-role/${params.customerId}/${params.roleCode}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const customerRoleApi = {
	getCustomerRoles,
	setCustomerRoles,
	grantCustomerRole,
	revokeCustomerRole,
}

export default customerRoleApi
